import { Component, OnInit, OnDestroy, Inject, PLATFORM_ID } from '@angular/core';
import { CommonModule, isPlatformBrowser, isPlatformServer } from '@angular/common';
// ngrx store
import { Subscription } from 'rxjs';
import { Store } from '@ngrx/store';
// services
// model
import { AppState } from '../../../booking/models/app-state.interface';
import { FormsModule } from '@angular/forms';
import { AppLoaderService } from '@shared/services/app-loader.service';
import { CopyService } from '@shared/services/app-copy.service';
import { TrustPilotComponent } from '@shared/components/trust-pilot/trust-pilot.component';
@Component({
  selector: 'app-page-loader',
  standalone: true,
  imports: [CommonModule, FormsModule, TrustPilotComponent],
  templateUrl: './page-loader.component.html',
  styleUrls: ['./page-loader.component.scss']
})
export class PageLoaderComponent implements OnInit, OnDestroy {

  private _copyInitSubscription: Subscription;
  private _userLanguageSubscription: Subscription;
  private _loaderItemSubscription: Subscription;

  public showLoader = false;
  public customCopy = '';
  public onlyCaptions = false;
  public copyLoaded: Boolean = false;
  public appCopy;
  public selectedLanguage = '';
  public onlyLoader = false;

  constructor(
    private _appStore: Store<AppState>,
    private _appLoaderService: AppLoaderService,
    private _copyService: CopyService,

    @Inject(PLATFORM_ID) private platformId: Object,
  ) { }

  ngOnInit() {

    // will work without reloading
    this._copyInitSubscription = this._appStore.select('loadedStatusReducer')
      .subscribe((res: any) => {
        // if booking data has bookingLoaded
        // show template and subscribe to data

        this.copyLoaded = res.copyLoaded;
        if (res.copyLoaded) {
          if (isPlatformBrowser(this.platformId)) {
            this.getCopy();
          }
        }
        this._userLanguageSubscription = this._appStore.select('copyReducer')
          .subscribe((res: any) => {
            this.selectedLanguage = res.language
          })

      });

    this._loaderItemSubscription = this._appLoaderService.loaderState$
      .subscribe(res => {
        if (res.show === true) {
          this.customCopy = res.data;
          this.onlyLoader = res.onlyLoader;
          this.onlyCaptions = res.onlyCaptions;
          this.showLoader = true;
        } else {
          this.showLoader = false;
        }
      });
  }


  getCopy() {
    const panelHeaderCopy = this._copyService.getCopyBySection(
      'OTHER',
      'loading',
      ['panelHeader']
    );

    this.appCopy = {
      panelHeader: panelHeaderCopy[0],
    };
  }

  ngOnDestroy() {
    if (this._copyInitSubscription) { this._copyInitSubscription.unsubscribe(); }
    this._loaderItemSubscription.unsubscribe();
    if (this._userLanguageSubscription) { this._userLanguageSubscription.unsubscribe(); }
  }

}
